import React, { useState, useEffect, useContext } from "react";
import { Col, Row, Form, Button, Spinner } from "react-bootstrap";
import DashboardSectionTitle from "../DashboardSectionTitle/DashboardSectionTitle";
import { Formik } from "formik";
import * as yup from "yup";
import { handleAlert } from "../../../util/util";

//Context
import AppContext from "../../../AppContext";

//Service
import recordService from "../../../services/Record";
import FieldError from "../../../ui/FieldError/FieldError";

function CreateThread(props) {
  const { setProfileStats } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const isAddMode = props.isAddMode;
  const initialCreateThreadValues = {
    title: "",
    description: "",
    // sort_order: 10
  };

  useEffect(() => {
    if (!isAddMode && props.existingThread) {
      setFormValues(props.existingThread);
    }
  }, [props.existingThread]);

  //Get Profile Stats
  function getUserProfileData() {
    recordService
      .getUserProfileData()
      .then((response) => {
        if (response.data.status === "success") {
          // console.log("Response from APP : ", response.data);
          const stats = response.data.data.result.details;
          setProfileStats(stats);
        }
        if (response.data.status === "failed") {
          console.log("ERROR:", response.data.error);
        }
      })
      .catch((err) => {
        console.log("There is a problem in fetching Profile Stats...", err);
      });
  }

  const createThreadSchema = yup.object({
    title: yup.string().max(100, "Title is too long!").required("Required"),
    description: yup.string().required("Required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    console.log("Create Thread Form Values :", values);
    const newValues = {
      ...values,
      forum_id: props.forum_id,
    };
    console.log("Create Thread Form Values :", newValues);
    setLoading(true);

    if (isAddMode) {
      console.log("Creating new Thread");
      recordService
        .createThread(newValues)
        .then((response) => {
          if (response.data.status === "success") {
            console.log(response.data);
            handleAlert("Success! Thread created.", "success");
            props.setThreadCount((prev) => prev + 1);
            setLoading(false);
            resetForm({});
            props.handleCollapse("create_thread");
            //get all forums
            props.handleThreadList(props.forum_id);

            //Get Profile Stats
            getUserProfileData();
          } else if (response.data.status === "failed") {
            console.log("ERROR:", response.data.error);
            handleAlert("Error! Failed to create thread.", "error");
            setLoading(false);
            resetForm({});
            props.handleCollapse("create_thread");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (!isAddMode) {
      console.log("Updating existing Thread");
      const updatedValues = {
        ...newValues,
        forum_thread_id: props.forum_thread_id,
      };
      recordService
        .updateThread(updatedValues)
        .then((response) => {
          if (response.data.status === "success") {
            console.log(response.data);
            handleAlert("Success! Thread updated.", "success");
            setLoading(false);
            resetForm({});
            props.handleCollapse("create_thread");
            // props.handleCollapse("view_threads");
            //get all forums
            props.handleThreadList(props.forum_id);
          } else if (response.data.status === "failed") {
            console.log("ERROR:", response.data.error);
            handleAlert("Error! Failed to update thread.", "error");
            setLoading(false);
            resetForm({});
            props.handleCollapse("create_thread");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <div className="form_style">
        <Formik
          initialValues={isAddMode ? initialCreateThreadValues : formValues}
          validationSchema={createThreadSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {(formik) => {
            return (
              <Form onSubmit={formik.handleSubmit}>
                <Row className="g-0">
                  {/* <Col xs={12}>
                    <Form.Group className="form-group rounded_corners px-1">
                      <Form.Label>Select Forum Group</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        className="form-control"
                      >
                        <option>Global</option>
                        <option>Local</option>
                        <option>Public</option>
                        <option>Private</option>
                      </Form.Select>
                    </Form.Group>
                  </Col> */}
                  <Col xs={12}>
                    <DashboardSectionTitle
                      iconImg=""
                      title="Thread Title"
                      pageTitle={false}
                      className="mb1 small_title"
                    />
                    <Form.Group className="form-group rounded_corners">
                      <Form.Control
                        type="text"
                        placeholder="Thread Title"
                        name="title"
                        {...formik.getFieldProps("title")}
                      />
                      <div class="text-end text_gray8">
                        <small>* Maximum 100 characters long!</small>
                      </div>
                      <FieldError
                        valid={
                          formik.touched.title && formik.errors.title
                            ? true
                            : false
                        }
                        text={formik.errors.title}
                      />
                      {/* {formik.touched.title && formik.errors.title ? (
                        <p className="error-state-text">
                          {formik.errors.title}
                        </p>
                      ) : null} */}
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <DashboardSectionTitle
                      iconImg=""
                      title="Thread Description"
                      pageTitle={false}
                      className="mb1 small_title"
                    />
                    <Form.Group className="form-group rounded_corners">
                      <Form.Control
                        as="textarea"
                        placeholder="Thread Description"
                        style={{ height: "140px" }}
                        name="description"
                        {...formik.getFieldProps("description")}
                      />
                      {formik.touched.description &&
                      formik.errors.description ? (
                        <p className="error-state-text">
                          {formik.errors.description}
                        </p>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <div className="btn_wrap">
                      <Button
                        type="submit"
                        className="btn btn_theme btn_primary btn_rounded"
                      >
                        {loading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            Processing
                          </>
                        ) : (
                          <>{isAddMode ? "Create Thread" : "Update Thread"}</>
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
}

export default CreateThread;
